import React from 'react';
import { Box, Tooltip } from '@mui/material';

// A number that opens the rows behind it. Keyboard friendly (Enter / Space), and it swallows the
// click so a number inside a team band doesn't also collapse the band.
export default function DrillValue({ children, onClick, tip = 'Click to see the rows behind this number' }) {
  const fire = (e) => {
    e.stopPropagation();
    onClick(e);
  };
  return (
    <Tooltip title={tip} arrow enterDelay={500}>
      <Box
        component="span"
        role="button"
        tabIndex={0}
        onClick={fire}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            fire(e);
          }
        }}
        sx={{
          cursor: 'pointer',
          borderRadius: '6px',
          px: 0.3,
          py: 0.1,
          '&:hover': { backgroundColor: 'rgba(21,101,192,0.12)' },
          '&:focus-visible': { outline: '2px solid #1565C0', outlineOffset: 1 },
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
}
